import React from "react";

import { Controller } from "react-hook-form";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const SelectController = ({ control, name, rules, options, ...props }) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <Select fullWidth {...field} {...props}>
        {options.map((item) => (
          <MenuItem key={`${name}-${item.id}`} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    )}
  />
);

export default SelectController;
